import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { podeEditarCampanha } from '../../core/utils/campanha-permissions.util';
import { CampanhaService } from '../../core/services/campanha.service';

/**
 * Campanhas que não aceitam alteração devem abrir a mesma tela em modo visualização,
 * inclusive quando a URL de edição é acessada diretamente.
 */
export const campanhaEdicaoGuard: CanActivateFn = (route) => {
  const id = route.paramMap.get('id');
  const modo = route.queryParamMap.get('modo');

  if (!id || modo === 'visualizar') {
    return true;
  }

  const campanhaService = inject(CampanhaService);
  const router = inject(Router);

  return campanhaService.obterCampanha(id).pipe(
    map((campanha) => {
      if (!campanha || podeEditarCampanha(campanha.status)) {
        return true;
      }

      return router.createUrlTree(['/campanhas', id, 'editar'], {
        queryParams: { modo: 'visualizar' },
      });
    }),
    catchError(() =>
      of(
        router.createUrlTree(['/campanhas', id, 'editar'], {
          queryParams: { modo: 'visualizar' },
        }),
      ),
    ),
  );
};
